"use strict";
/**
 * Controla la mida del window
 * Component: AppSizeMe.tsx
 * Llenguatge: TypeScrypt
 * Autors:
 * Versió: 1.1
 * Data: 08/11/2018
 * (c) Ajuntament de Manresa - nov 2018 - Departament de Sistemes d'Informació
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var mobx_react_1 = require("mobx-react");

var AppSizeMe =
/** @class */
function (_super) {
  __extends(AppSizeMe, _super);

  function AppSizeMe() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AppSizeMe.prototype.updateDimensions = function () {
    if (this.props.appState) {
      this.props.appState.pantState.updateWindowSize();
    }
  };
  /**
   * Add event listener
   */


  AppSizeMe.prototype.componentDidMount = function () {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
  };
  /**
   * Remove event listener
   */


  AppSizeMe.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  };

  AppSizeMe.prototype.render = function () {
    return React.createElement("div", {
      id: "app-size-me"
    }, this.props.children);
  };

  AppSizeMe = __decorate([mobx_react_1.inject('appState')], AppSizeMe);
  return AppSizeMe;
}(React.Component);

exports.default = AppSizeMe;